import { useMediaQuery, useTheme } from '@material-ui/core';
import { ICheckoutTheme } from '../theme/ICheckoutTheme';

export default function useIsTablet(): boolean {
  const theme = useTheme<ICheckoutTheme>();
  return useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
}
